import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {AuthorizationGuardService} from 'src/app/shared/authorization-guard/authorization-guard.service';
import {USER_ROLE} from '@constants/user-role.constant';
import {PortalSetupComponent} from '@components/administration/portal-setup/portal-setup.component';

const routes: Routes = [
  {path: '', redirectTo: '/login', pathMatch: 'full'},
  {
    path: 'portalsetup', component: PortalSetupComponent, canActivate: [AuthorizationGuardService],
    data: {roles: [USER_ROLE.ADMIN, USER_ROLE.TECH_ADMIN, USER_ROLE.SUPERADMIN]}
  }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ]
})
export class PortalSetupRoutingModule {
}
